import type { FC } from "react";
import React, { useMemo } from "react";

import cn from "classnames";

import { HEADER_SHOW_ALL_TEST_ID } from "./utils/createTestId";
import { extractProps, getChildrenRecord } from "../../../utils/react";
import { CoreHeader } from "../general/CoreHeader/CoreHeader";

import type { HeaderProps } from "../general/CoreHeader/types";

import classes from "./HeaderShowAll.styl";

export const HEADER_SHOW_ALL_DISPLAY_NAME = "HeaderShowAll";

/**
 * Компонент для отображения и разметки заголовков, основан на CoreHeader.
 *
 * Умеет отображать заголовки нескольких уровней, в качестве rightAddon предустановлен buttonInline.
 *
 * <a href="https://www.figma.com/design/vTg3KAvmAXA9LigeyiqCWL/%F0%9F%92%A0-Base-Components?node-id=7340-465466&m=dev" target="_blank">Спека</a>
 * @constructor
 */
export const HeaderShowAll: FC<HeaderProps> = (props) => {
    const {
        customVarsStyles,
        currentProps: {
            view = "primary",
            children,
            "data-tsid": tsid = HEADER_SHOW_ALL_TEST_ID,
            ...restProps
        },
    } = useMemo(() => extractProps(props, ["customVarsStyles"]), [props]);

    const content = useMemo(
        () =>
            getChildrenRecord(
                children,
                HEADER_SHOW_ALL_DISPLAY_NAME,
                {
                    Title: {
                        props: { view },
                        required: true,
                    },
                    CounterInline: {
                        props: { view },
                    },
                    Subtitle: {
                        props: { view },
                    },
                    RightButtonInline: {
                        props: { view },
                    },
                    Unknown: {
                        skipElement: true,
                    },
                },
                { isArrayResult: true },
            ),
        [children, view],
    );

    const headerShowAllStyles = cn(
        classes["header-show-all"],
        customVarsStyles,
    );

    return (
        <CoreHeader
            {...restProps}
            customVarsStyles={headerShowAllStyles}
            data-tsid={tsid}
            data-uikit={HEADER_SHOW_ALL_DISPLAY_NAME}
            view={view}
            prefix="HeaderShowAll"
        >
            {content}
        </CoreHeader>
    );
};

HeaderShowAll.displayName = HEADER_SHOW_ALL_DISPLAY_NAME;

export default HeaderShowAll;
